import { useRef } from 'react';

import { useLayer } from '@coursera-web/statsig';

import { isAuthenticatedUser } from 'js/lib/user';

export const MIX_AND_MATCH_ORDERING_LAYER_NAME = 'optimize-mix-and-match-user-layer';

/**
 * Reads the `optimize-mix-and-match-user` Statsig experiment (MONETIZE-3207). Treatment ranks the
 * course's s12ns by recent enrollments and auto-selects the top one instead of showing the picker.
 *
 * `.get()` logs an exposure, so it's only called once the learner reaches the s12n selection
 * decision (`isEligible`), and the result is cached so re-renders don't log again.
 */
const useMixAndMatchOrderingTreatment = (isEligible: boolean): boolean => {
  const layer = useLayer(MIX_AND_MATCH_ORDERING_LAYER_NAME);
  const isTreatmentRef = useRef<boolean | undefined>(undefined);

  if (!isEligible || !isAuthenticatedUser()) {
    return false;
  }

  if (isTreatmentRef.current === undefined) {
    isTreatmentRef.current = layer.get('variant', 'control') === 'test';
  }

  return isTreatmentRef.current;
};

export default useMixAndMatchOrderingTreatment;
